function firstLetterUpper(theString) {
  const safeString = String(theString ?? '').trim()
  if (!safeString) return ''
  var newString = safeString.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g,function(c){return c.toUpperCase()});
  return newString;
}

export const toSentenceCase = (str) => {
  var theString = str
  var newString = firstLetterUpper(theString);
  return newString;
}

export const capitalize = (str, lower = false) => {
  const safeString = String(str ?? '')
  return (lower ? safeString.toLowerCase() : safeString).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase())
}

export const formatDetailText = (value, emptyValue = '-') => {
  const safeValue = String(value ?? '').trim()
  if (!safeValue) return emptyValue
  return capitalize(safeValue, true)
}

export const normalizeText = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase()

export const capitalizeEachWord = (str) =>
  String(str ?? '')
    .trim()
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

export const getMultiDisplayText = (selectedValues = [], options = []) => {
  const values = Array.isArray(selectedValues) ? selectedValues : []
  if (!values.length) return ''
  const selected = options.filter(opt => values.includes(opt.value))
  if (selected.length <= 2) return selected.map(opt => opt.label).join(', ')
  return `${selected[0].label} +${selected.length - 1}`
}

  export const orderBy = (array, key) => {
  return [...array].sort((a, b) => {
    if (a[key] < b[key]) return -1
    if (a[key] > b[key]) return 1
    return 0
  })
}